import classnames from 'classnames';
import type { ComponentProps } from 'react';
import css from './styles.module.scss';

export default function List(props: ComponentProps<'ul'>) {
  const className = classnames(props.className, css.list, 'full-bleed');

  return <ul {...props} className={className} />;
}
